// extracted by mini-css-extract-plugin
export default {"title":"CTABanner_title__f9rnn","pitstopGif":"CTABanner_pitstopGif__SGqAv"};